import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/src/components/layout-wiki/index.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>{`Contributing`}</h1>
    <h2>{`How can I participate?`}</h2>
    <p>{`The pages are located on `}<a parentName="p" {...{
        "href": "https://github.com/polarity/bitwig.community"
      }}>{`github.com`}</a>{` and can be changed there either directly (you
need a repository membership) or you fork the repo and start a pull request (after a
short check the pull request will be accepted or rejected).`}</p>
    <p>{`If you aren't sure where to start, check out the TODO list for ideas on topics that have
yet to be written:`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "todo"
        }}>{`TODO list`}</a></li>
    </ul>
    <h2>{`Where are all the Files?`}</h2>
    <p>{`The wiki pages are all located in the subdirectory `}<inlineCode parentName="p">{`src/pages/wiki`}</inlineCode>{` and can easily be
filled with `}<a parentName="p" {...{
        "href": "https://www.markdownguide.org/cheat-sheet/"
      }}>{`markdown`}</a>{` (use .mdx for new files). After every change, the website will
be regenerated and published on `}<a parentName="p" {...{
        "href": "https://bitwig.community/wiki/"
      }}>{`bitwig.community/wiki`}</a></p>
    <h2>{`Forking the repo`}</h2>
    <p>{`In addition to editing pages directly on Github, if you plan to make more extensive
changes, a better approach would be to create your own fork of the wiki repository, make
changes there, and then submit a pull request.`}</p>
    <p>{`The basic steps involved are:`}</p>
    <ol>
      <li parentName="ol">{`Create an account on Github.`}</li>
      <li parentName="ol">{`Click the "fork" button to create your own fork of the repository`}</li>
      <li parentName="ol"><inlineCode parentName="li">{`git clone <your fork>`}</inlineCode></li>
      <li parentName="ol">{`(Make changes...)`}</li>
      <li parentName="ol"><inlineCode parentName="li">{`git add`}</inlineCode></li>
      <li parentName="ol"><inlineCode parentName="li">{`git commit`}</inlineCode></li>
      <li parentName="ol"><inlineCode parentName="li">{`git push`}</inlineCode></li>
      <li parentName="ol">{`Create a pull request including your changes.`}</li>
    </ol>
    <p>{`When using this approach, you will also need to be sure to update your forked versions
of the git repo from time to time (particularly, before you plan to make new changes),
retrieving any changes that have been made since your last pull.`}</p>
    <p>{`To do this, first tell Git where to find the upstream version of the repo:`}</p>
    <pre><code parentName="pre" {...{}}>{`git remote add upstream https://github.com/polarity/bitwig.community
`}</code></pre>
    <p>{`Now, whenever you want to sync your local forked version of the repo with the main
upstream version, you can simply do:`}</p>
    <pre><code parentName="pre" {...{}}>{`git pull upstream master
`}</code></pre>
    <p>{`For more a more detailed explanation of the above workflow, checkout:`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://guides.github.com/activities/forking/"
        }}>{`Github - Forking Projects`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://reflectoring.io/github-fork-and-pull/"
        }}>{`Github's Fork & Pull Workflow for Git Beginners`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      